var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTumblr = function SvgTumblr(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20264_101724)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 8,
    fill: "#345272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5315 0C10.0771 0 0 10.0842 0 22.4842C0 34.8843 10.0771 45 22.5315 45C34.92 45 45 34.8814 45 22.4842C45 10.0182 34.9229 0 22.5315 0Z",
    fill: "#345272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2798 27.5548C24.2798 29.5837 25.3035 30.2839 26.9324 30.2839H29.2438V35.4408H24.8676C20.9274 35.4408 17.9909 33.4119 17.9909 28.5592V20.788H14.4062V16.5782C18.3465 15.5537 19.9954 12.1617 20.1847 9.22021H24.2769V15.8952H29.0516V20.788H24.2798V27.5548Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20264_101724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTumblr);
export default ForwardRef;